<template>
  <div id="empresa-listagem">
    <my-tour
      v-if="itens.length > 0"
      :steps="steps"
      name="steps-empresas"
    ></my-tour>
    <section id="content">
      <!--start container-->
      <div class="container">
        <TituloPagina :titulo="lang.empresa" />
        <div class="row">
          <div class="col s12 m12 l12">
            <div class="card-panel">
              <div class="col s12 m12 l12">
                <h4>Filtros de busca <i class="material-icons prefix">search</i></h4>
              </div>
              <div class="col s12 m6 xl3">

                <label for="empresaStatus">Buscar pelo Status</label>

                <multiselect v-model="status" :options="options_status" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="false" placeholder="Selecione os Status" label="name" track-by="name" :preselect-first="false">
                <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Status selecionados</span></template>
                </multiselect>

              </div>
              <div class="input-field col s12 m6 xl3">
                <input id="empresa_id" type="text" v-model="empresa_id" class="validate">
                <label for="empresa_id">Buscar pelo ID da empresa</label>
              </div>
              <div class="input-field col s12 m6 xl3">
                <input id="razao_social" type="text" v-model="empresa_razao_social" class="validate">
                <label for="razao_social">Buscar pela Razão Social</label>
              </div>
              <div class="input-field col s12 m6 xl3">
                <masked-input
                  type="text"
                  id="empresaCNPJ"
                  v-model="empresa_cnpj"
                  mask="11111111/1111-11"
                />
                <label for="empresaCNPJ"
                  >Buscar pelo CNPJ</label
                >
              </div>
              <div class="col s12">
                <div v-if="isloadingCompany" class="col s12" style="text-align: center; margin-top: 3rem;">
                    <h6>Buscando empresas...</h6>
                    <pulse-loader :loading="loading" :color="blue" :size="size"></pulse-loader>
                </div>
              </div>

              <div class="col s12 botao-busca text-right" style="">

                   <a class="waves-effect waves-light  mt-4 " @click="clearSearch(),getEmpresas()" style="margin-right: 20px; text-align: center;"><i class="material-icons">close</i> <br>Limpar</a>
                   <a class="waves-effect waves-light  mt-4"  @click="getEmpresas()" style="margin-right: 20px; text-align: center;"><i class="material-icons">search</i> <br>Pesquisar</a>

              </div>

              <table class="bordered striped">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th class="hide-on-med-and-down">CNPJ</th>
                    <th>Razão social</th>
                    <th style="display:none">Tipo</th>
                    <th>Telefone</th>
                    <th>Email</th>
                    <th style="display:none">Pode indicar?</th>
                    <th>Status</th>
                    <th id="colAcaoEmpresa" class="center">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in itens.data"
                    :id="'item-' + item.empresa_id"
                    :key="item.empresa_id"
                    v-if="item.empresa_tipo_id != 3"
                  >
                    <td class="hide-on-med-and-down">{{ item.empresa_id }}</td>
                    <td class="hide-on-med-and-down">
                      {{ item.empresa_cnpj }}
                    </td>
                    <td>{{ item.empresa_razao_social }}</td>
                    <td style="display:none">{{ item.empresa_tipo.empresa_tipo_nome }}</td>
                    <td>{{ item.telefone }}</td>
                    <td style="text-transform:lowercase;font-size:10px;">{{ item.email }}</td>
                    <td style="display:none">
                      <template v-if="item.empresa_tipo_id == 2">
                        {{ item.pode_indicar ? "Sim" : "Não" }}
                      </template>
                      <template v-else>-</template>
                    </td>
                    <td>{{ item.status_corretor }}</td>
                    <td class="center">
                      <router-link
                        title="Dados cadastrais da empresa"
                        :to="'/empresa/editar/' + item.empresa_id"
                        class="btn-floating btn-flat btn-transparent"
                      >
                        <i class="material-icons text-default">mode_edit</i>
                      </router-link>
                      <router-link
                        title="Enviar Logo da empresa"
                        :to="{
                          name: 'empresa_upload_logo',
                          params: { id: item.empresa_id },
                        }"
                        class="hide"
                      >
                        <i class="material-icons text-default">photo</i>
                      </router-link>
                      <router-link
                        title="Tema da empresa"
                        :to="{
                          name: 'empresa_tema',
                          params: { id: item.empresa_id },
                        }"
                        class="hide"
                      >
                        <i class="material-icons text-default">color_lens</i>
                      </router-link>

                       <botao-remover
                          :identificador="item.empresa_id"
                          :url="'empresa/' + item.empresa_id"


                        >
                        </botao-remover>

                    </td>
                </tr>
                 <tr v-for="item in filhas" :key="item.empresa_id">
                    <td class="hide-on-med-and-down">{{ item.empresa_id }}</td>
                    <td class="hide-on-med-and-down">{{ item.empresa_cnpj }}</td>
                    <td class="hide-on-med-and-down">{{ item.empresa_razao_social }}</td>
                    <td class="hide-on-med-and-down">{{ item.telefone }}</td>
                    <td class="hide-on-med-and-down">{{ item.email }}</td>
                    <td class="hide-on-med-and-down">{{ item.status_corretor }}</td>
                    <td class="center">

                    <router-link
                        title="Dados cadastrais da empresa"
                        :to="'/empresa/editar/' + item.empresa_id"
                        class="btn-floating btn-flat btn-transparent"
                      >
                        <i class="material-icons text-default">mode_edit</i>
                    </router-link>

                    <router-link
                        title="Enviar Logo da empresa"
                        :to="{
                          name: 'empresa_upload_logo',
                          params: { id: item.empresa_id },
                        }"
                        class="hide"
                      >
                        <i class="material-icons text-default">photo</i>
                    </router-link>

                    <router-link
                        title="Tema da empresa"
                        :to="{
                          name: 'empresa_tema',
                          params: { id: item.empresa_id },
                        }"
                        class="hide"
                      >
                        <i class="material-icons text-default">color_lens</i>
                    </router-link>

                    <botao-remover
                          :identificador="item.empresa_id"
                          :url="'empresa/' + item.empresa_id"


                        >
                    </botao-remover>

                    </td>
                  </tr>
                  <tr v-for="item in filhas_das_filhas" :key="item.empresa_id">
                    <td class="hide-on-med-and-down">{{ item.empresa_id }}</td>
                    <td class="hide-on-med-and-down">{{ item.empresa_cnpj }}</td>
                    <td class="hide-on-med-and-down">{{ item.empresa_razao_social }}</td>
                    <td class="hide-on-med-and-down">{{ item.telefone }}</td>
                    <td class="hide-on-med-and-down">{{ item.email }}</td>
                    <td class="hide-on-med-and-down">{{ item.status_corretor }}</td>
                    <td class="center">

                    <router-link
                        title="Dados cadastrais da empresa"
                        :to="'/empresa/editar/' + item.empresa_id"
                        class="btn-floating btn-flat btn-transparent"
                      >
                        <i class="material-icons text-default">mode_edit</i>
                    </router-link>

                    <router-link
                        title="Enviar Logo da empresa"
                        :to="{
                          name: 'empresa_upload_logo',
                          params: { id: item.empresa_id },
                        }"
                        class="hide"
                      >
                        <i class="material-icons text-default">photo</i>
                    </router-link>

                    <router-link
                        title="Tema da empresa"
                        :to="{
                          name: 'empresa_tema',
                          params: { id: item.empresa_id },
                        }"
                        class="hide"
                      >
                        <i class="material-icons text-default">color_lens</i>
                    </router-link>

                    <botao-remover
                          :identificador="item.empresa_id"
                          :url="'empresa/' + item.empresa_id"


                        >
                    </botao-remover>

                    </td>
                  </tr>
                </tbody>
              </table>
              <pagination
                :data="itens"
                @pagination-change-page="getEmpresas"
                :limit="4"
                :show-disabled="true"
              >
                <span slot="prev-nav">&lt; Anterior</span>
                <span slot="next-nav">Próximo &gt;</span>
              </pagination>
            </div>
          </div>
        </div>
      </div>
      <!--end container-->
    </section>
    <div class="fixed-action-btn active" style="bottom: 50px; right: 19px">
      <router-link
        to="/empresa/cadastro"
        id="add-empresa"
        class="btn-floating btn-large btn-default"
      >
        <i class="material-icons">add</i>
      </router-link>

    </div>
  </div>
</template>
<script>
import { PulseLoader } from 'vue-spinner/dist/vue-spinner.min.js'
import BotaoRemover from "@/components/common/BotaoRemover";
import MaskedInput from 'vue-masked-input';
import { get, post } from "@/helpers/api";
import MyTour from "@/components/common/MyTour.vue";
import TituloPagina from "@/components/common/TituloPagina";
import {
  DONO,
  GERENTE,
  CORRETOR,
  ESPECIALISTA,
  LIDER,
  MASTER,
  PARCEIRO,
} from "@/constants/funcionarioCargo.js";
import Auth from "@/store/auth";
import TourHelper from "@/helpers/tour";
import getPalavra from "@/helpers/language";
import { api } from "@/helpers/api";
import Multiselect from 'vue-multiselect'

export default {
  components: {
    BotaoRemover,
    MyTour,
    TituloPagina,
    MaskedInput,
    Multiselect,
    PulseLoader
  },
  data () {



  },
  data: () => ({
      tipo_arquivo: 'pdf',
      isloading: false,
      isloadingCompany: false,
      childrens: [],
      childrens_of_childrens: [],
      value: [

      ],
      options: [
        { name: 'Acre', code: 'AC' },
        { name: 'Alagoas', code: 'AL' },
        { name: 'Amapá', code: 'AP' },
        { name: 'Amazonas', code: 'AM' },
        { name: 'Bahia', code: 'BA' },
        { name: 'Distrito Federal', code: 'DF' },
        { name: 'Espírito Santo', code: 'ES' },
        { name: 'Goiás', code: 'GO' },
        { name: 'Maranhão', code: 'MA' },
        { name: 'Mato Grosso', code: 'MT' },
        { name: 'Mato Grosso do Sul', code: 'MS' },
        { name: 'Minas Gerais', code: 'MG' },
        { name: 'Pará', code: 'PA' },
        { name: 'Paraíba', code: 'PB' },
        { name: 'Paraná', code: 'PR' },
        { name: 'Pernambuco', code: 'PE' },
        { name: 'Piauí', code: 'PI' },
        { name: 'Rio de Janeiro', code: 'RJ' },
        { name: 'Rio Grande do Norte', code: 'RN' },
        { name: 'Rio Grande do Sul', code: 'RS' },
        { name: 'Rondônia', code: 'RO' },
        { name: 'Roraima', code: 'RR' },
        { name: 'Santa Catarina', code: 'SC' },
        { name: 'São Paulo', code: 'SP' },
        { name: 'Sergipe', code: 'SE' },
        { name: 'Tocantins', code: 'TO' },
      ],
      seguradoras: [

      ],
      options_seguradoras: [
        { name: 'Advanced', coluna: 'advanced'},
        { name: 'Bradesco', coluna: 'bradesco_seguros'},
        { name: 'Caixa Consórcio', coluna: 'caixa_newcon'},
        { name: 'Centauro On', coluna: 'centauro'},
        //{ name: 'Compacta', coluna: ''},
        { name: 'Embracon', coluna: 'embracon_consorcio'},
        //{ name: 'Espaço Consultor', coluna: ''},
        { name: 'Fiduc', coluna: 'fiduc_vinculo'},
        { name: 'Icatu', coluna: 'icatu_vida_horizonte_login'},
        { name: 'IHB', coluna: 'ihb'},
        { name: 'Juspromed', coluna: 'juspromed'},
        //{ name: 'Mapfre Bien Vivir', coluna: ''},
        { name: 'Mapfre BR Consórcios', coluna: 'mapfre_cod'},
        { name: 'Metlife', coluna: 'metlife'},
        { name: 'MAG', coluna: 'mongeral_cod'},
        { name: 'Omint', coluna: 'omint_online'},
        { name: 'Porto Seguro', coluna: 'porto_cod'},
        { name: 'Prudential', coluna: 'prudential_cpf'},
        { name: 'Remax', coluna: 'remax'},
        { name: 'Sucursal', coluna: 'sucursal'},
        { name: 'Sulamérica', coluna: 'sulamerica_cod'},
        //{ name: 'Unicarreiras', coluna: ''},
        { name: 'Unimed', coluna: 'unimed_cod'},
        { name: 'Vumi', coluna: 'vumi'},
        { name: 'Zurich', coluna: 'zurich_cod'},

      ],
      campos_tabela: [],
      options_campo_tabela: [],
      produtos: [],
      options_produtos: [
          {name: 'Área de Crédito', code: 'consorcio'},
          {name: 'Vida', code: 'vida'},
          {name: 'Saúde', code: 'saude'},
          {name: 'Previdência ', code: 'previdencia'},
      ],
      status:[

      ],
      options_status: [
        {name: 'Ativo', value: 'ativo'},
        {name: 'Ativo sem Susep', value: 'ativo sem susep'},
        {name: 'Inativo', value: 'inativo'},
        {name: 'Desvinculado', value: 'desvinculado'},
        {name: 'Em processo de Cadastro', value: 'em processo de cadastro'},
      ],
    lang: {
      empresa: getPalavra("empresa", false, true),
    },


    itens: {},
    nomeEmpresa: null,
    empresa_id: null,
    status_corretor: null,
    empresa_cnpj: null,
    razao_social: null,
    estado: null,
    cargoDono: null,
    cargoGerente: null,
    cargoCorretor: null,
    cargoParceiro: null,
    isModalVisible: false,
    empresa_modal: {},
    empresa_selecionada: {
      empresa: null,
      imagens: null,
    },

    steps: [
      {
        parent: ".card-panel",
        target: ".card-panel",
        content: `Podemos ver a lista de ${getPalavra(
          "empresa",
          true,
          true
        )} já cadastradas...`,
        params: {
          cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
          placement: "bottom",
          menu: false,
        },
      },
      {
        parent: "#colAcaoEmpresa",
        target: "#colAcaoEmpresa",
        content: "...e editá-las!",
        params: {
          cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
          placement: "bottom",
          menu: false,
        },
      },
      {
        parent: "#add-empresa",
        target: "#add-empresa",
        content: `Ou então cadastrar uma nova ${getPalavra("empresa", true)}!`,
        params: {
          cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
          placement: "left",
          bgTransparent: true,
          bgClass: "color-default",
          menu: true,
          route: "/empresa/cadastro",
        },
      },

      {
        parent: "",
        target: "",
        content: "",
        params: {
          cargos: [DONO, PARCEIRO, GERENTE, CORRETOR, ESPECIALISTA, LIDER],
          placement: "left",
          menu: false,
          // route: '/gerenciamento-leads'
        },
      },
    ],
  }),
  created() {
    // verifica se pode acessar componente
    if (
      Auth.getCargoUsuario() !== MASTER &&
      [DONO, GERENTE, ESPECIALISTA, PARCEIRO].indexOf(Auth.getCargoUsuario()) === -1
    ) {
//      this.$router.push("/sempermissao");
    }
    this.steps = TourHelper.createSteps(this.steps);
    let self = this;
    this.cargoDono = DONO;
    this.cargoGerente = GERENTE;
    this.cargoCorretor = CORRETOR;
    this.getEmpresas();
    this.getCamposTabela();
  },
  methods: {
    addTag (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.value.push(tag)
    },
    showModal() {
      this.isModalVisible = true;
    },
    empresa(data) {
      this.empresa_modal = data;
    },
    removeEmpresa(){

      api.delete("remove-empresa", {params: {id: item.empresa_id}}).then((response) => {

      });
    },
    async getCamposTabela() {
        let self = this;
        await get("empresa/colunas-tabela").then((response) => {
            let data = response.data.result.data;
            self.options_campo_tabela = data;
            self.options_campo_tabela = Object.values(self.options_campo_tabela);


        });
    },
    getEmpresas(page = 1) {

        this.isloadingCompany = true

      /*api.get("empresa?page=" + page, {params: {search: this.nomeEmpresa}}).then((response) => {
        this.itens = response.data.result.data;

      });*/
      //var cnpj = this.empresa_cnpj.replace(/[^0-9]/g, '');
            //Tratamento select seguradoras
            var selected_seg = Object.keys(this.seguradoras).length;
            var seguradoras = [];
            var i = 0;
            for(i = 0; i < selected_seg; i++){
              if (selected_seg - 1 == i){
                seguradoras += [this.seguradoras[i].coluna]
              }else{
                seguradoras += [this.seguradoras[i].coluna] + '-';
              }

              var seg = seguradoras.split("-");

            }
            //Tratamento select status
            var status_selected = Object.keys(this.status).length;
            var status = [];
            var i = 0;
            for(i = 0; i < status_selected; i++){
              if (status_selected - 1 == i){
                status += [this.status[i].value]
              }else{
                status += [this.status[i].value] + ',';
              }

              var state = status.split(",");

            }

            //Tratamento select Estados
            var uf_selecteds = Object.keys(this.value).length;
            var estado = [];
            var i = 0;
            for(i = 0; i < uf_selecteds; i++){
              if (uf_selecteds - 1 == i){
                estado += [this.value[i].code]
              }else{
                estado += [this.value[i].code] + ' ';
              }

              var uf = estado.split(" ");

            }


      api.get("empresa?page=" + page, {params: {search: this.nomeEmpresa, empresaID: this.empresa_id, status: state, CNPJ: this.empresa_cnpj, razao_social: this.empresa_razao_social, estado: uf, seguradoras: seg, tipo_busca: this.tipo_busca}}).then((response) => {
        this.isloadingCompany = false;
        const data = response.data.result.data;
        this.itens = data
        this.childrens = this.itens.data.map((item, index) => { return item.children});
        this.childrens_of_childrens = this.itens.data.map((item, index) => { return item.children_of_children});

        this.filhas = [];
        this.filhas_das_filhas = [];

        for(let index = 0; index < this.childrens.length; index++){
            if(this.childrens[index].length > 0){
               this.filhas.push(this.childrens[index]);
            }
        }

        this.filhas = this.filhas.flat(Infinity);


        const buildTree = (tree) => {
            tree.forEach((item) => {
                if (item.children_of_children) {
                    buildTree (item.children_of_children);
                    if(item.children_of_children[0] !== undefined) {
                      this.filhas_das_filhas.push(item.children_of_children[0]);
                    }
                }
            });
        }

        buildTree (this.filhas.flat(Infinity));

      });
    },
       clearSearch(){
        this.nomeEmpresa = '';
        this.value = '';
        this.seguradoras = '';
        this.tipo_arquivo = '';
        this.empresa_id = '';
        this.status_corretor = '';
        this.empresa_cnpj = '';
        this.campos_tabela = '';
        this.tipo_busca = '';
        this.empresa_razao_social = '';
        this.uf = '';
        this.status = '';

    }
  },

  mounted() {
    $(".modal").modal();

  },
};
</script>
<!-- New step!
     Add Multiselect CSS. Can be added as a static asset or inside a component. -->
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scopped>
.cyan {
  background-color: #44a3ac;
  color: #fff;
}

.btn-outlined {
  background: transparent;
  border: 1px solid #44a3ac;
  color: #44a3ac;
  box-shadow: none;
}

.btn-outlined:hover {
  background: transparent;
}

.left {
  margin-right: 10px;
}

@media only screen and (min-width: 601px) and (max-width: 992px) {
    .mt-md-2 {
        margin-top: 2% !important;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/empresas/Listagem.vue